import React, { useState } from "react";
import "./login.scss";
import * as Yup from "yup";
import India from "../../../assets/images/flags/india.png";
import USA from "../../../assets/images/flags/united-states-of-america.png";
import { toast } from "react-toastify";
import {
  useLoginMutation
} from "../../../utils/apiSlice";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
export default function LoginPage() {
  const [selectedCountry, setSelectedCountry] = useState("IN");
  const [login] = useLoginMutation();
  const countries = [
    { code: "IN", name: "India", flag: India },
    { code: "US", name: "USA", flag: USA },
  ];

  const selected = countries.find((c) => c.code === selectedCountry);

  const [initialValues, setInitialValues] = useState<any>({
    email: "",
    password: "",
    memberId: "",
    remember: false,
  });
  const navigate = useNavigate();
  const validationSchema = Yup.object()
    .shape({
      email: Yup.string(),
      memberId: Yup.string(),
      password: Yup.string()
        .required("Password is required")
        .min(8, "Password must be at least 8 characters")
        .matches(/[A-Z]/, "Must contain at least one uppercase letter")
        .matches(/[a-z]/, "Must contain at least one lowercase letter")
        .matches(/[0-9]/, "Must contain at least one number")
        .matches(
          /[!@#$%^&*(),.?\":{}|<>]/,
          "Must contain at least one special character"
        ),
    })
    .test(
      "email-or-memberId",
      "Either email or Member ID is required",
      function (value) {
        if (!value?.email && !value?.memberId) {
          return this.createError({
            path: "email", // error will appear under email
            message: "Either email or Member ID is required",
          });
        }
        return true;
      }
    );






  const handleSubmit = async (data: any, reset: any) => {
    console.log(data);
    try {

      const loginData = {
        email: data.email.trim(),
        password: data.password.trim(),
      };

      const response: any = await login(loginData).unwrap()

      if (response) {
        const { token, roles, ...rest } = response;

        // Handle storing tokens in sessionStorage or localStorage
        if (data.remember) {
          localStorage.setItem("token", token);
          localStorage.setItem("userData", JSON.stringify(rest));

          // Retrieve existing users from localStorage
          let users: any[] = JSON.parse(localStorage.getItem("users") || "[]");

          // Check if the user is already in the list
          const existingUserIndex = users?.findIndex(
            (user: any) => user.email === data.email
          );

          if (existingUserIndex === -1) {
            // If user is not in the list, add the new user
            users.push({ email: data.email, password: data.password });

            // Ensure the array only contains 10 unique users
            if (users.length > 10) {
              users.shift(); // Remove the first (oldest) user
            }

            // Save updated list back to localStorage
            localStorage.setItem("users", JSON.stringify(users));
          }
        } else {
          localStorage.setItem("token", token);

          localStorage.setItem("userData", JSON.stringify(rest));
        }

        const rolesArray = roles.includes(",") ? roles.split(",") : [roles];
        localStorage.setItem("roles", JSON.stringify(rolesArray));

        toast.success("User logged in successfully");
        navigate("/dashboard");
      } else {
        toast.error(
          response?.response?.data?.detail
            ? response?.response?.data?.detail
            : "Login Error"
        );
      }
    } catch (error: any) {
      if (error.response) {
        toast.error(error.response.data.message || "Login error");
      } 
    } 
  };

  return (
    <div className="container-fluid h-p100 auth-container">
      <div className="row align-items-center justify-content-md-center h-p100">
        <div className="col-12">
          <div className="row justify-content-center g-0">
            <div className="col-lg-12 col-md-12 col-12">
              <div className="rounded10 shadow-lg translucent-card p-4">
                <div className="card-country-select mb-3">
                  <div className="country-dropdown position-relative">
                    {selected && (
                      <img
                        src={selected.flag}
                        alt={selected.name}
                        className="country-flag"
                      />
                    )}

                    <select
                      className="form-control country-select"
                      value={selectedCountry}
                      onChange={(e) => setSelectedCountry(e.target.value)}
                    >
                      {countries.map((c) => (
                        <option key={c.code} value={c.code}>
                          {c.name}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                <div className="content-top-agile p-20 pb-0 text-center">
                  <h2>Let's Get Started</h2>
                  <p className="mb-0">Sign inn to continue to Drug Sync.</p>
                </div>

                <div className="p-40 form-input-container">
                  <Formik
                    initialValues={initialValues}
                    validationSchema={validationSchema}
                    onSubmit={handleSubmit}
                  >
                    {({ }) => (
                      <Form>
                        {/* email */}
                        <div className="form-group">
                          <div className="input-group mb-3">
                            <span className="input-group-text bg-white">
                              <i className="ti-user"></i>
                            </span>

                            <Field
                              type="text"
                              name="email"
                              className="form-control ps-15"
                              placeholder="email"
                            />

                          </div>
                          <ErrorMessage
                            name="email"
                            component="div"
                            className="text-danger"
                          />
                        </div>

                        {/* OR Divider */}
                        <div className="or-section text-center">
                          <hr className="or-txt-line" />
                          <span className="or-txt">OR</span>
                          <hr className="or-txt-line" />
                        </div>

                        {/* Member ID */}
                        <div className="form-group">
                          <div className="input-group mb-3">
                            <span className="input-group-text bg-white">
                              <i className="ti-id-badge"></i>
                            </span>

                            <Field
                              type="text"
                              name="memberId"
                              className="form-control ps-15"
                              placeholder="Member ID"
                            />

                          </div>
                          <ErrorMessage
                            name="memberId"
                            component="div"
                            className="text-danger"
                          />
                        </div>

                        {/* Password */}
                        <div className="form-group">
                          <div className="input-group mb-3">
                            <span className="input-group-text bg-white">
                              <i className="ti-lock"></i>
                            </span>

                            <Field
                              type="password"
                              name="password"
                              className="form-control ps-15"
                              placeholder="Password"
                            />

                          </div>
                          <ErrorMessage
                            name="password"
                            component="div"
                            className="text-danger"
                          />
                        </div>

                        {/* Remember */}
                        <div className="row">
                          <div className="col-6">
                            <div className="checkbox">
                              <Field
                                type="checkbox"
                                name="remember"
                                id="basic_checkbox_1"
                              />
                              <label htmlFor="basic_checkbox_1">
                                Remember Me
                              </label>
                            </div>
                          </div>

                          <div className="col-6 text-end">
                            <Link to="/" className="hover-warning">
                              Forgot Password?
                            </Link>
                          </div>

                          <div className="col-12 text-center mt-3">
                            <button type="submit" className="btn btn-danger">
                              SIGN IN
                            </button>
                          </div>
                        </div>
                      </Form>
                    )}
                  </Formik>

                  <div className="text-center mt-3">
                    <p>
                      Don't have an account?{" "}
                      <Link to="/register" className="text-warning ms-1">
                        Register
                      </Link>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
